<script setup lang="ts">
import type { HeroBlock } from '../../types'
import SiteEditableText from '../../SiteEditableText.vue'
import SiteImageAttribution from '../../SiteImageAttribution.vue'
import SiteLink from '../../SiteLink.vue'

defineProps<{ block: HeroBlock }>()
</script>

<template>
  <section class="site:bg-(--site-color-background) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container site:text-center">
      <div class="site:mx-auto site:max-w-3xl">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h1" class="site-heading site:mt-4 site:text-4xl site:font-bold site:tracking-tight site:@min-[40rem]:text-6xl" />
        <SiteEditableText v-model="block.content.description" as="p" class="site:mx-auto site:mt-6 site:max-w-2xl site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
        <div class="site:mt-8 site:flex site:flex-wrap site:justify-center site:gap-3">
          <SiteLink class="site-site-button" :link="block.content.primaryAction">
            {{ block.content.primaryAction.label }}
          </SiteLink>
          <SiteLink v-if="block.content.secondaryAction" class="site-site-button-secondary" :link="block.content.secondaryAction">
            {{ block.content.secondaryAction.label }}
          </SiteLink>
        </div>
      </div>
      <figure
        v-if="block.content.image"
        class="site:relative site:mt-12 site:aspect-[16/7] site:w-full site:overflow-hidden site:shadow-(--site-shadow-md)"
        :style="{ borderRadius: 'var(--site-radius-lg)' }"
      >
        <img :src="block.content.image.src" :alt="block.content.image.alt" class="site:h-full site:w-full site:object-cover" fetchpriority="high" />
        <SiteImageAttribution v-if="block.content.image.attribution" :image="block.content.image" class="site:absolute site:bottom-2 site:right-2" />
      </figure>
      <ul v-if="block.content.highlights?.length" class="site:mt-12 site:flex site:flex-wrap site:justify-center site:gap-x-8 site:gap-y-3 site:text-sm site:font-medium site:@min-[40rem]:mt-14">
        <SiteEditableText v-for="(_, index) in block.content.highlights" :key="index" v-model="block.content.highlights![index]" as="li" />
      </ul>
    </div>
  </section>
</template>
